import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@cmde/shadcn";
import { SearchIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function FilteredEmptyCredentialsList() {
  const { t } = useTranslation();

  return (
    <Empty className="border border-solid bg-white/30">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <SearchIcon />
        </EmptyMedia>
        <EmptyTitle>{t("credentials.list.general.no_matching_credentials_found")}</EmptyTitle>
        <EmptyDescription>
          {t("credentials.list.general.try_adjusting_your_search_terms")}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent />
    </Empty>
  );
}
